import h from '../h';
import { getDates } from '../utils';
import Year from './Year';
export default function MonthHeader(_ref) {
  var styles = _ref.styles,
      unit = _ref.unit,
      minTime = _ref.minTime,
      maxTime = _ref.maxTime,
      offsetY = _ref.offsetY,
      maxTextWidth = _ref.maxTextWidth;
  var MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var dates = getDates(minTime, maxTime);
  var months = dates.filter(function (v) {
    return new Date(v).getDate() === 1;
  });
  months.unshift(minTime);
  months.push(maxTime);
  var ticks = [];
  var x0 = maxTextWidth;
  var y0 = offsetY / 2;
  var len = months.length - 1;

  for (var i = 0; i < len; i++) {
    var cur = new Date(months[i]);
    var month = cur.getMonth();
    var x = x0 + (months[i] - minTime) / unit;
    var t = (months[i + 1] - months[i]) / unit;
    ticks.push(h("g", null, h("line", {
      x1: x,
      x2: x,
      y1: y0,
      y2: offsetY,
      style: styles.line
    }), t > 30 ? h("text", {
      x: x + t / 2,
      y: offsetY * 0.75,
      style: styles.text3
    }, MONTH[month]) : null));
  }

  return h("g", null, h(Year, {
    styles: styles,
    unit: unit,
    months: months,
    offsetY: offsetY,
    minTime: minTime,
    maxTime: maxTime,
    maxTextWidth: maxTextWidth
  }), ticks);
}